// fly.customer.io accesses assets from unityassets.customer.io, but web
// workers can't be accessed cross-domain.
// This hack allows us to load the web worker as a blob and initialize it
// from that.
// https://github.com/webpack/webpack/discussions/14648#discussioncomment-2559969
export class CorsWorker {
  private readonly worker: Worker;

  constructor(url: string | URL) {
    let absoluteUrl = new URL(url, window.location.href).toString();
    let workerSource = `\
  const urlString = ${JSON.stringify(absoluteUrl)}
  const originURL = new URL(urlString)
  const originalImportScripts = self.importScripts
  self.importScripts = (url) => originalImportScripts.call(self, new URL(url, originURL).toString())
  importScripts(urlString);
`;
    let blob = new Blob([workerSource], { type: 'application/javascript' });
    let objectURL = URL.createObjectURL(blob);
    this.worker = new Worker(objectURL);
    URL.revokeObjectURL(objectURL);
  }

  getWorker() {
    return this.worker;
  }
}
